/* ---------------------------------------------------------------------------
   pg-theme.js

   The BigCommerce theme's interactivity came from theme-bundle.main.js, which
   boots Stencil against BigCommerce's jsContext and cart API. None of that
   exists on Shopify, so the behaviour the ported CSS assumes is reimplemented
   here: accordion tabs, the image gallery, variant selection, the mega menu and
   the mobile nav toggle.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* ---- Accordion tabs --------------------------------------------------- */
  function initTabs() {
    document.querySelectorAll('.tabs').forEach(function (list) {
      list.querySelectorAll('.tab > .tab-title').forEach(function (title) {
        title.addEventListener('click', function () {
          var tab = title.parentElement;
          var isOpen = tab.classList.contains('is-active');

          tab.classList.toggle('is-active', !isOpen);
          title.setAttribute('aria-expanded', String(!isOpen));

          var glyph = title.querySelector('.self-tab-icon');
          if (glyph) glyph.textContent = isOpen ? '+' : '−';
        });
      });
    });
  }

  /* ---- Mobile menu (BC's #sideBlock_menu drill-down) -------------------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-pg-mobile-menu]');
    var block = document.getElementById('sideBlock_menu');
    if (!toggle || !block) return;

    function setOpen(open) {
      document.body.classList.toggle('has-activeNavPages', open);
      block.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!document.body.classList.contains('has-activeNavPages'));
    });
    block.querySelectorAll('[data-pg-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(false); });
    });
    /* click on the page overlay (body::after) closes it, as on BC */
    document.addEventListener('click', function (e) {
      if (!document.body.classList.contains('has-activeNavPages')) return;
      if (block.contains(e.target) || toggle.contains(e.target)) return;
      setOpen(false);
    });

    function show(id) {
      block.querySelectorAll('.menu-panel').forEach(function (p) {
        p.classList.remove('active', 'prev');
      });
      var target = document.getElementById(id);
      if (target) target.classList.add('active');
    }
    block.querySelectorAll('[data-pg-menu-open]').forEach(function (li) {
      li.addEventListener('click', function () { show(li.getAttribute('data-pg-menu-open')); });
    });
    block.querySelectorAll('[data-pg-menu-back]').forEach(function (el) {
      el.addEventListener('click', function () { show(el.getAttribute('data-pg-menu-back')); });
    });
    block.querySelectorAll('[data-pg-menu-link]').forEach(function (li) {
      li.addEventListener('click', function () {
        window.location.href = li.getAttribute('data-pg-menu-link');
      });
    });
  }

  /* ---- Product image gallery ------------------------------------------- */
  function initGallery() {
    var main = document.getElementById('pg-main-image');
    if (!main) return;

    document.querySelectorAll('[data-image-gallery-item]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        main.removeAttribute('srcset');
        main.src = link.getAttribute('href');

        document.querySelectorAll('[data-image-gallery-item]').forEach(function (other) {
          other.classList.remove('is-active');
        });
        link.classList.add('is-active');
      });
    });
  }

  /* ---- Variant selection ------------------------------------------------
     Reads the variant JSON the section prints, matches on the selected option
     values, then updates the hidden id input, price, SKU and button state. */
  function initVariants() {
    var dataEl = document.getElementById('pg-variant-data');
    var form = document.getElementById('pg-product-form');
    if (!dataEl || !form) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-pg-option]'));
    if (!selects.length) return;

    var idInput = form.querySelector('[data-pg-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare-price]');
    var skuEl = document.querySelector('[data-product-sku]');
    var button = form.querySelector('button[type="submit"]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function update() {
      var chosen = selects.map(function (s) { return s.value; });

      var match = variants.find(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      });

      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (skuEl && match.sku) skuEl.textContent = match.sku;

      // The struck "was" price is per-variant; hide it on variants that aren't
      // discounted rather than leaving the previous variant's figure showing.
      if (compareEl) {
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.textContent = onSale ? formatMoney(match.compare_at_price) : '';
        compareEl.hidden = !onSale;
      }

      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? 'Add to Cart' : 'Out of Stock';
      }

      if (match.featured_image && match.featured_image.src) {
        var main = document.getElementById('pg-main-image');
        if (main) {
          main.removeAttribute('srcset');
          main.src = match.featured_image.src;
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---- Mega menu -------------------------------------------------------- */
  function initMegaMenu() {
    document.querySelectorAll('.navPages-item.has-megamenu').forEach(function (item) {
      var trigger = item.querySelector('.pg-mega__trigger');
      var panel = item.querySelector('.pg-mega__panel');
      if (!trigger || !panel) return;

      function open() { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);

      // Keyboard: let the trigger toggle rather than navigate straight away.
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          item.classList.contains('is-open') ? close() : open();
        }
        if (event.key === 'Escape') { close(); trigger.focus(); }
      });
    });
  }

  /* ---- Mega-menu sidebar tabs -------------------------------------------
     Each sidebar item swaps which .pg-mega__block is active, matching the live
     storefront's behaviour. Hover for pointer users, focus for keyboard. */
  function initMegaTabs() {
    document.querySelectorAll('.pg-mega__panel').forEach(function (panel) {
      var tabs = panel.querySelectorAll('[data-mega-tab]');
      var blocks = panel.querySelectorAll('[data-mega-panel]');
      if (!tabs.length || !blocks.length) return;

      function activate(key) {
        tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.megaTab === key); });
        blocks.forEach(function (b) { b.classList.toggle('active', b.dataset.megaPanel === key); });
      }

      tabs.forEach(function (tab) {
        var key = tab.dataset.megaTab;
        tab.addEventListener('mouseenter', function () { activate(key); });
        var link = tab.querySelector('a');
        if (link) link.addEventListener('focus', function () { activate(key); });
      });
    });
  }

  /* ---- Mobile nav ------------------------------------------------------- */
  /* The old .pg-mobile-toggle stub is gone — the mobile header now uses BC's
     hamburger + #sideBlock_menu drill-down, wired in initMobileMenu above. */

  /* ---- Quantity stepper -------------------------------------------------
     BC's theme JS drove .form-increment; that bundle can't port, so the +/-
     buttons are wired here. Respects the input's min and fires `change` so the
     variant/price logic still sees it. */
  function initQuantityStepper() {
    document.querySelectorAll('[data-pg-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('input[name="quantity"]');
      if (!input) return;

      wrap.querySelectorAll('[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var current = parseInt(input.value, 10);
          if (isNaN(current)) current = min;
          var next = btn.dataset.action === 'inc' ? current + 1 : current - 1;
          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Thumbnail rail arrows --------------------------------------------
     Scrolls the vertical rail and disables an arrow once that end is reached. */
  function initThumbRail() {
    document.querySelectorAll('[data-pg-thumbrail]').forEach(function (rail) {
      var list = rail.querySelector('[data-pg-thumbs]');
      if (!list) return;
      var up = rail.querySelector('[data-thumb-scroll="up"]');
      var down = rail.querySelector('[data-thumb-scroll="down"]');

      function step() {
        var first = list.querySelector('.productView-thumbnail');
        return first ? first.offsetHeight + 8 : 80;
      }

      function sync() {
        var max = list.scrollHeight - list.clientHeight;
        var atTop = list.scrollTop <= 1;
        var atEnd = list.scrollTop >= max - 1;
        var scrollable = max > 1;
        if (up) { up.disabled = atTop || !scrollable; up.hidden = !scrollable; }
        if (down) { down.disabled = atEnd || !scrollable; down.hidden = !scrollable; }
      }

      if (up) up.addEventListener('click', function () { list.scrollBy({ top: -step(), behavior: 'smooth' }); });
      if (down) down.addEventListener('click', function () { list.scrollBy({ top: step(), behavior: 'smooth' }); });
      list.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
    });
  }

  /* ---- Build Your Kit ---------------------------------------------------
     BC's kitAddToCart() added the main product through the storefront endpoint,
     re-read the cart to get its id, then pushed the accessories over GraphQL.
     Shopify's /cart/add.js takes the whole lot in one request, so this is a
     single call. The main product is skipped when it can't be bought, which is
     what the submit button's disabled state tells us. */
  function initBuildKit() {
    var kit = document.querySelector('[data-pg-kit]');
    if (!kit) return;

    var button = kit.querySelector('[data-pg-kit-add]');
    var error = kit.querySelector('[data-pg-kit-error]');
    var form = document.getElementById('pg-product-form');
    if (!button || !form) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function showError(message) {
      if (!error) return;
      if (message) error.textContent = message;
      error.hidden = false;
    }

    button.addEventListener('click', function () {
      var checked = Array.prototype.slice.call(kit.querySelectorAll('[data-pg-kit-variant]:checked'));

      if (error) error.hidden = true;

      if (!checked.length) {
        showError();
        setTimeout(function () { if (error) error.hidden = true; }, 5000);
        return;
      }

      var items = [];

      var variantInput = form.querySelector('[data-pg-variant-id]');
      var submit = form.querySelector('button[type="submit"]');
      var mainAvailable = !(submit && submit.disabled);

      if (mainAvailable && variantInput && variantInput.value) {
        var qtyInput = form.querySelector('input[name="quantity"]');
        var qty = parseInt(qtyInput && qtyInput.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        items.push({ id: variantInput.value, quantity: qty });
      }

      checked.forEach(function (box) { items.push({ id: box.value, quantity: 1 }); });

      var label = button.textContent;
      button.disabled = true;
      if (button.dataset.waitLabel) button.textContent = button.dataset.waitLabel;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function (err) {
          button.disabled = false;
          button.textContent = label;
          showError(err.message);
        });
    });
  }

  /* ---- Cart count ------------------------------------------------------- */
  function refreshCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { el.textContent = cart.item_count; })
      .catch(function () { /* leave the server-rendered count in place */ });
  }

  /* ---- Slick carousels --------------------------------------------------
     The live storefront runs Slick for the hero and the services row. Without
     an init the slides simply stack, which is what the first port did. jQuery
     and Slick are loaded with `defer` ahead of this file, so they are ready. */
  /* BC's Best Sellers slider, config copied verbatim from their home page:
     mobileFirst 2-up, 3-up from 768, 4-up from 992, infinite, custom arrows. */
  function initBestSellers($) {
    var $el = $('[data-pg-bestsellers]');
    if (!$el.length || $el.hasClass('slick-initialized')) return;
    $el.slick({
      arrows: true,
      dots: false,
      autoPlay: false,
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      infinite: true,
      pauseOnHover: true,
      slide: '[data-best-seller-slide]',
      nextArrow: '<button type="button" class="slick-next slick-arrow-custom"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none"><path d="M15.6114 9.88843L16.1613 9.33854L16.7112 9.88843L16.1613 10.4383L15.6114 9.88843ZM3.94477 10.6662C3.73849 10.6662 3.54066 10.5843 3.3948 10.4384C3.24894 10.2925 3.16699 10.0947 3.16699 9.88843C3.16699 9.68215 3.24894 9.48432 3.3948 9.33846C3.54066 9.1926 3.73849 9.11065 3.94477 9.11065V10.6662ZM11.4947 4.67188L16.1613 9.33854L15.0615 10.4383L10.3949 5.77165L11.4947 4.67188ZM16.1613 10.4383L11.4947 15.105L10.3949 14.0052L15.0615 9.33854L16.1613 10.4383ZM15.6114 10.6662H3.94477V9.11065H15.6114V10.6662Z" fill="#787878"/></svg></button>',
      prevArrow: '<button type="button" class="slick-prev slick-arrow-custom"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none"><path d="M3.38856 9.88843L2.83867 9.33854L2.28879 9.88843L2.83867 10.4383L3.38856 9.88843ZM15.0552 10.6662C15.2615 10.6662 15.4593 10.5843 15.6052 10.4384C15.7511 10.2925 15.833 10.0947 15.833 9.88843C15.833 9.68215 15.7511 9.48432 15.6052 9.33846C15.4593 9.1926 15.2615 9.11065 15.0552 9.11065V10.6662ZM7.50534 4.67188L2.83867 9.33854L3.93845 10.4383L8.60512 5.77165L7.50534 4.67188ZM2.83867 10.4383L7.50534 15.105L8.60512 14.0052L3.93845 9.33854L2.83867 10.4383ZM3.38856 10.6662H15.0552V9.11065H3.38856V10.6662Z" fill="#787878"/></svg></button>',
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 4 } }
      ]
    });
  }

  function initCarousels() {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;
    var $ = window.jQuery;
    initBestSellers($);

    $('[data-pg-carousel]').each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      $el.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: $el.data('autoplay') !== false,
        autoplaySpeed: parseInt($el.data('autoplay-speed'), 10) || 6000,
        // adaptiveHeight measures the slide before images have loaded and then
        // writes height:0 inline on .slick-list, collapsing the hero. The
        // wrapper carries an aspect-ratio instead, so this must stay off.
        adaptiveHeight: false,
        pauseOnHover: true,
      });

      // Slick's inline track geometry is computed at init; recalculate once the
      // slide images have actually loaded.
      var recalc = function () { $el.slick('setPosition'); };
      $(window).on('load', recalc);
      $el.find('img').each(function () {
        if (this.complete) return;
        this.addEventListener('load', recalc, { once: true });
      });
    });

    $('[data-pg-carousel-multi]').each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      var per = parseInt($el.data('per-view'), 10) || 4;
      $el.slick({
        slidesToShow: per,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: Math.min(per, 3) } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 560, settings: { slidesToShow: 1 } },
        ],
      });
    });
  }

  function init() {
    initTabs();
    initGallery();
    initVariants();
    initMegaMenu();
    initMegaTabs();
    initMobileMenu();
    initCarousels();
    initQuantityStepper();
    initThumbRail();
    initBuildKit();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
